import React from 'react';

const Footer = () => {
    return (
        <>
            <footer className="footer footer-wrapper">
                <div className="footer-content">
                    <div className="footer-copyright">
                        <div className="copyright-wrapper">
                            <div className="copyright-caption">
                                <p className="copyright-caption-title">© CyberBearz Army, 2021. All right reserved.</p>
                                <div className="copyright-caption-links">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-xs-12">
                        </div>
                    </div>
                </div>
            </footer>
       </>
    );
};

export default Footer;